module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYUO0EpFhYAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEVwUPCAeHCQMCjwUDD40DD4+Pj///+js/TvAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABnSURBVAjXXY67DUJBDAQtRAPW6uUIKjgG50jQwAbuvxUCjs+9yTzSaB3H58I9Hizcgh0B1a5Wm269ReawvMk5hcC45G8iTJv2FCmMjZP/ZPsloloufVaGGKkcyrmye+yy3tc4nBdOL8ROLCtpd17EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Fire.png
// module id = 163
// module chunks = 0